// extracted by mini-css-extract-plugin
module.exports = {"containterOrder":"VsjSi6oJMpxXEX5HvTTpKA==","selectNombre":"-H5AxpjEXzphmM7mrLvA1g==","selectPeso":"LBoP4zPBJAY3fbcTd5g0lg=="};